<template>
  <div class="item-bar">
    <img src="../assets/img/icon-bar-gray.png" style="width: 100%; height: 50px;" />
    <div class="main">
      <el-image
        class="main-img"
        :src="require('@/assets/img/icon-bar-point.png')"
      ></el-image>
      <div class="main-title">{{ title }}</div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HeaderBar',
  props: {
    title: String,
  },
};
</script>

<style lang="scss">
.item-bar {
  position: relative;
  width: 100%;
  border-left: 1px solid #DCDCDC;
  border-right: 1px solid #DCDCDC;
  border-top: 1px solid #DCDCDC;
  box-sizing: border-box;
  border-radius: 15px 15px 0px 0px;
  overflow: hidden;
  .main {
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: 50px;
    top: 0px;
    left: 20px;
    .main-img {
      width: 10px;
      height: 10px;
    }
    .main-title {
      margin-left: 10px;
      color: #006117;
      font-weight: bold;
      text-shadow: 0 0 5px white, 0 0 5px white;
    }
  }
}
</style>
